import React from 'react'
import { privacy } from '../../../../content/site'

// Privacy Policy hero, on the new design system (Task 11). Same dark .hero-section
// treatment as About, Services, FAQ and Contact (reuses .about-hero-inner's single-column
// grid override verbatim) so all six pages read as siblings, per the task brief. Title,
// "Last updated" line and lead paragraph are copied verbatim from the old
// src/pages/public/privacypolicy/hero/index.jsx (git 8cc2307) - no eyebrow existed there,
// so none is invented here, same reasoning Contact/FAQ's heroes followed.
const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero about-hero-inner -reading">
        <h1>{privacy.hero.title}</h1>
        <p className="hero-desc about-hero-desc privacy-hero-updated">{privacy.hero.lastUpdated}</p>
        <p className="hero-desc about-hero-desc">{privacy.hero.intro}</p>
      </div>
    </section>
  )
}

export default Hero
